export default "__VITE_ASSET__4dcb4e16__"